import { defineNuxtPlugin } from '#app/nuxt';
import { useStore } from '#imports';
import { blockAdapterEvents } from '#layers/block-engine/public';
import { mapBlockDataToSerialized, mapSerializedToBlockData } from '~/utils/block-adapter';

export default defineNuxtPlugin(() => {
	const store = useStore();

	const offLoadBlock = blockAdapterEvents.loadBlockSerialized.on(async ({ id, setResult }) => {
		const block = await store.MonospaceBlock.findFirst(id);
		setResult(block ? mapBlockDataToSerialized(block) : undefined);
	});

	const offLoadBlocks = blockAdapterEvents.loadBlocksSerialized.on(async ({ setResult }) => {
		const blocks = await store.MonospaceBlock.findMany();
		setResult(blocks.map((block) => mapBlockDataToSerialized(block)));
	});

	const offSaveBlock = blockAdapterEvents.saveBlockSerialized.on(async ({ block, markHandled }) => {
		await store.MonospaceBlock.update(mapSerializedToBlockData(block));
		markHandled();
	});

	import.meta.hot?.dispose(() => {
		offLoadBlock.off();
		offLoadBlocks.off();
		offSaveBlock.off();
	});
});
